import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
} from "../../../Common/DataTable";
import { draftEmailList, rowSorting } from "../../../store/actions";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useParams } from "react-router-dom";

// const Mobile = (value) => {
//   console.log(value, "value");
//   return value && value.firstname;
// };

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "email_content",
    align: false,
    disablePadding: true,
    label: "Email",
    title: "Email",
    order: 1,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];
const FacebookMessageIndex = () => {
  const dispatch = useDispatch();
  const { editId } = useParams();
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [filterBy, setFilterBy] = useState("email");
  const adminId = localStorage && localStorage.getItem("id");
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    searchBy: "email",
    search: "",
  });
  const [dragUsers, setDragUsers] = useState("");

  const DraftEmails = useSelector((s) => s.Customers?.draftEmails?.data);

  useEffect(() => {
    if (DraftEmails) {
      setDragUsers(DraftEmails);
    }
  }, [DraftEmails]);

  useEffect(() => {
    if (editId && adminId) {
      dispatch(
        draftEmailList({
          sender_id: adminId,
          receiver_id: editId,
          type: "draft",
        })
      );
    }
  }, [editId, adminId]);

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "social_subscriber_facebooks",
    };
    dispatch(rowSorting(body));
  };

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Draft Emails</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box">
                <div className="table-responsive py-3">
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <DataTable className="">
                      <DataTableHead
                        columns={columnData}
                        orderBy={state.orderBy}
                        //   sort={handleRequestSort}
                        tableData={dragUsers}
                      />
                      <Droppable droppableId="droppable-1">
                        {(provider) => (
                          <DataTableBody
                            loading={loading}
                            column={columnData}
                            data={dragUsers}
                            page={state.page}
                            rowsPerPage={state.limit}
                            innerRef={provider.innerRef}
                            dropProp={provider.droppableProps}
                            actionBtn={[
                              {
                                label: "Mail",
                                icon: "",
                                link: `/customers/mail/${editId}`,
                              },
                            ]}
                          />
                        )}
                      </Droppable>
                    </DataTable>
                  </DragDropContext>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FacebookMessageIndex;
